import { render, staticRenderFns } from "./nav-bar-manage.vue?vue&type=template&id=2e54a82c&"
import script from "./nav-bar-manage.vue?vue&type=script&lang=js&"
export * from "./nav-bar-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports